import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AdminBffService } from '@http/admin-bff.service';
import { PUBLIC_URLS } from '@navUrls';
import { UserService } from '@services/user.service';
import { AuthUrl } from '@serviceUrls';

/**
 * The authService manages the authToken
 */
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private adminBffService: AdminBffService, private userService: UserService, private router: Router) {}

  /**
   * Exchange the SSO token with the backend to get an AuthToken
   * @param ssoCode Code from the SSO service
   * @param redirectUri Url the user should be redirected to
   */
  public exchangeToken(ssoCode: string, redirectUri: string): Observable<void> {
    // We cannot use the bffService here, because that would lead to a circular dependency
    return this.adminBffService
      .get<{ meta: { idToken: string; message: string } }>({
        url: AuthUrl.exchangeToken(),
        params: {
          code: ssoCode,
          redirectUri,
        },
        withCredentials: true,
        headers: new HttpHeaders({ noToken: 'true' }),
      })
      .pipe(
        // Do not forward the response
        map(() => undefined)
      );
  }

  /**
   * Logs out the current user, by removing the session cookie (is removed by the backend response) and resetting the user data
   */
  public logout(): void {
    this.adminBffService
      .post<void>({
        url: AuthUrl.logout(),
      })
      .subscribe(async () => {
        // Reset the user data
        this.userService.invalidateUser();
        // Navigate to login screen
        await this.router.navigate(PUBLIC_URLS.authentication.getUrlSegments());
      });
  }
}
